// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSignOutAlt, faCircle, faFilePdf } from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'

import VueEnv from '@websanova/vue-env'
import BladeAuth from '../src/services/auth'
import AppStream from '../src/services/appstream'
import RouteHandler from '../src/services/routehandler'
import ModuleHelpers from '../src/services/helpers'
import EventBus from '../src/services/eventbus'

Vue.use(VueEnv)
Vue.use(Vuelidate)
Vue.use(ModuleHelpers)
Vue.use(EventBus)

library.add(faSignOutAlt, faCircle, faFilePdf)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)

Vue.config.productionTip = process.env.NODE_ENV === 'production'

Vue.router = router

Vue.use(VueAxios, axios)
Vue.use(RouteHandler, {router: router})

const isProd = process.env.NODE_ENV === 'production'

// const isProd = true

Vue.axios.defaults.baseURL = isProd ? Vue.env.get('API_URL') : 'http://localhost:63509/api'

console.log(Vue.axios.defaults.baseURL)

Vue.use(BootstrapVue)

Vue.use(BladeAuth, {
  http: axios
})

Vue.use(AppStream, {
  http: axios
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js